"use strict";

define(["dojo/_base/declare", "dojo/_base/lang", "mw-log/Log"], function (declare, lang, Log) {
  //noinspection JSUnusedLocalSymbols,FunctionWithInconsistentReturnsJS
  /**
   * Observable interface for peer model objects.
   */
  var Observable = declare([], {
    /**
     * Add an event listener for the specified type of event.
     * @param type Type of event to observe.
     * @param callback Observer (can be a string if the scope is specified).
     * @param scope Optional scope to use for the listener.
     */
    addEventListener: function addEventListener(type, callback, scope) {},
    /**
     * Remove the listener which was added using the exact same type and observer instances.
     * @param type Type of event listener to remove.
     * @param callback Observer used to add the event listener.
     * @param scope Optional scope to use for the listener.
     */
    removeEventListener: function removeEventListener(type, callback, scope) {},
    /**
     * Check if a listener has been added.
     * @param type Type of event listener.
     * @param callback Observer used to add the listener.
     * @param scope Optional scope to use for the listener.
     * @return True if the exact same listener (with the same scope) has been added for the
     * specified type of event.
     */
    hasEventListener: function hasEventListener(type, callback, scope) {},
    /**
     * Dispatch a custom event.
     * @param type The type of event.
     * @param target The target node of the event.
     * @param data The custom data for the event.
     * @param originator Optional originator object for this event.
     */
    dispatchEvent: function dispatchEvent(type, target, data, originator) {}
  });

  //noinspection FunctionWithInconsistentReturnsJS,JSUnusedLocalSymbols
  /**
   * Observable interface for peer model objects.
   */
  Observable.Syncable = declare([], {
    /**
     * Add a synchronizer event listener for the specified type of event.
     * @param type Type of event to observe.
     * @param callback Observer (can be a string if the scope is specified).
     * @param scope Optional scope to use for the listener.
     */
    addSyncEventListener: function addSyncEventListener(type, callback, scope) {},
    /**
     * Remove the synchronizer listener which was added using the exact same type and observer
     * instances.
     * @param type Type of event listener to remove.
     * @param callback Observer used to add the event listener.
     * @param scope Optional scope to use for the listener.
     */
    removeSyncEventListener: function removeSyncEventListener(type, callback, scope) {}
  });

  // Make the impl available on the exported class
  Observable.Impl = declare([Observable, Observable.Syncable], {
    constructor: function constructor() {
      this._listeners = {};
      this._syncListeners = {};
    },
    addEventListener: function addEventListener(type, callback, scope) {
      this._addEventListener(this._listeners, type, callback, scope);
    },
    addSyncEventListener: function addSyncEventListener(type, callback, scope) {
      this._addEventListener(this._syncListeners, type, callback, scope);
    },
    _addEventListener: function _addEventListener(listeners, type, callback, scope) {
      scope = scope || this;
      listeners[type] = listeners[type] || [];
      var listener = {
        scope: scope,
        callback: callback
      };
      if (this._getEventListenerIndex(listeners, type, callback, scope) < 0) {
        listeners[type].push(listener);
      }
    },
    hasEventListener: function hasEventListener(type, callback, scope) {
      return this._getEventListenerIndex(this._listeners, type, callback, scope) >= 0;
    },
    removeEventListener: function removeEventListener(type, callback, scope) {
      this._removeEventListener(this._listeners, type, callback, scope);
    },
    removeSyncEventListener: function removeSyncEventListener(type, callback, scope) {
      this._removeEventListener(this._syncListeners, type, callback, scope);
    },
    _removeEventListener: function _removeEventListener(listeners, type, callback, scope) {
      scope = scope || this;
      var listenerIndex = this._getEventListenerIndex(listeners, type, callback, scope);
      if (listenerIndex >= 0) {
        listeners[type].splice(listenerIndex, 1);
      } else {
        throw new Error("Listener does not exist");
      }
    },
    _getEventListenerIndex: function _getEventListenerIndex(allListeners, type, callback, scope) {
      scope = scope || this;
      var listeners = allListeners[type];
      var i;
      if (listeners) {
        var listenersLength = listeners.length;
        for (i = 0; i < listenersLength; i += 1) {
          if (listeners[i].scope === scope && listeners[i].callback === callback) {
            return i;
          }
        }
      }
      return -1;
    },
    dispatchEvent: function dispatchEvent(type, target, data, originator) {
      // First dispatch to sync event listeners then normal listeners.
      this._dispatchEvent(this._syncListeners, type, target, data, originator);
      this._dispatchEvent(this._listeners, type, target, data, originator);
    },
    _dispatchEvent: function _dispatchEvent(allListeners, type, target, data, originator) {
      if (data !== undefined && (lang.isArray(data) || lang.isString(data) || data === null || typeof data === "number" || typeof data === "boolean")) {
        throw new Error("Invalid event data, must be object");
      }
      var i;
      var listeners = allListeners[type];
      if (listeners) {
        listeners = listeners.slice(0); // create a private copy to iterate over
        var listenersLength = listeners.length;
        for (i = 0; i < listenersLength; i += 1) {
          try {
            var event = {
              type: type,
              target: target || this,
              data: data || {},
              originator: originator
            };
            if (typeof listeners[i].callback === "string") {
              listeners[i].scope[listeners[i].callback].call(listeners[i].scope, event);
            } else {
              listeners[i].callback.call(listeners[i].scope, event);
            }
          } catch (e) {
            Log.error("Error while dispatching event handler of type: " + type + ", message: " + e);
          }
        }
      }
    }
  });
  return Observable;
});
//# sourceMappingURL=Observable.js.map
